export default __webpack_public_path__ + "static/un-05b44fa64abb34e7e264deaa36fd6506.svg";